// src/pages/support/PlannedGiving.js
import React from "react";
import { Helmet } from "react-helmet";
import dummyImage from "../../assets/images/support/plannedgiving.webp";
import CTASection from "../../components/CTASection"; // Import the CTASection component
import styled from "styled-components";

const PlannedGiving = () => {
  const description = `
    Planned giving allows you to make a lasting impact on Habitat for Humanity Buffalo. By including Habitat Buffalo in your will or estate plan, you can ensure that future generations benefit from your generosity.
  `;

  const waysToSupport = [
    "Include Habitat Buffalo in your will",
    "Designate Habitat Buffalo as a beneficiary",
    "Set up a charitable trust",
  ];

  return (
    <>
      <Helmet>
        <title>Planned Giving - Habitat for Humanity Buffalo</title>
        <meta
          name="description"
          content="Make a lasting impact with planned giving. Include Habitat Buffalo in your will or estate plan to support future generations."
        />
      </Helmet>
      <Container>
        <ImageSection>
          <img src={dummyImage} alt="Planned Giving" />
        </ImageSection>
        <DescriptionSection>
          <h1>Planned Giving</h1>
          <p>{description}</p>
          <h2>Ways to Support</h2>
          <ul>
            {waysToSupport.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </DescriptionSection>

        {/* Add CTASection for Planned Giving */}
        <CTASection
          title="Start Planned Giving"
          description="Ready to make a lasting impact? Click the button below to get started with your planned giving."
          buttonText="Get Started"
          buttonLink="/form/giving"
        />
      </Container>
    </>
  );
};

// Add necessary styled components here
const Container = styled.div`
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const ImageSection = styled.div`
  text-align: center;
  img {
    max-width: 100%;
    border-radius: 10px;
    margin-bottom: 20px;
  }
`;

const DescriptionSection = styled.div`
  margin-bottom: 40px;

  h1 {
    font-size: 2.5em;
    color: var(--primary-color);
  }

  p {
    font-size: 1.2em;
    line-height: 1.8;
    margin-bottom: 20px;
  }

  h2 {
    font-size: 1.8em;
    margin-bottom: 10px;
  }

  ul {
    list-style-type: disc;
    margin-left: 20px;
  }

  li {
    font-size: 1.1em;
    margin-bottom: 10px;
  }
`;

export default PlannedGiving;
